import React from 'react';
import Table from '@mui/material/Table';
import {
  TableBody, TableCell, TableHead, TableRow, TableContainer, Paper, TableFooter,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { getDeviceType } from 'utils';

const useStyles = makeStyles({
  table: {
    minWidth: 200,
  },
});

export default ({
  columns = [],
  footer = [],
  rows,
  name = 'common',
  onCellClick = () => {},
  smallScreenHideRowsIndex = [],
}) => {
  const classes = useStyles();

  if (smallScreenHideRowsIndex.length && getDeviceType() < 2) {
    rows = rows.map((e) => {
      const keys = Object.keys(columns);
      smallScreenHideRowsIndex.map((i) => {
        delete e[i];
        delete columns[keys[i]];
        return 0;
      });
      return e;
    });
  }

  return (!!rows.length && (
    <TableContainer component={Paper} style={{ marginTop: 20 }} className={`table-view table-view-${name}`}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            {columns.map((column, i) => {
              let style = {};
              let rowName = '';
              if (typeof column === 'string') {
                rowName = column;
              } else if (typeof column === 'object') {
                style = column.sytle || {};
                rowName = column.name || '';
              }
              return <TableCell key={i} style={style}>{rowName}</TableCell>;
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => (
            <TableRow key={i}>
              {row.map((e, j) => {
                const { link, value } = e || {};
                const { isNumber = false } = columns[j] || {};
                const align = isNumber ? 'right' : 'left';

                if (link !== undefined && value !== undefined) {
                  return (
                    <TableCell
                      align={align}
                      key={j}
                      onClick={() => onCellClick(link)}
                    >
                      <span className="table-view-clickable">{value}</span>
                    </TableCell>
                  );
                }

                return <TableCell align={align} key={j}>{e}</TableCell>;
              })}
            </TableRow>
          ))}
        </TableBody>
        {!!footer.length && (
          <TableFooter>
            <TableRow>
              {footer.map(({ name: rowName, style = {}, colspan = 0 }, i) => {
                const { isNumber = false } = columns[i] || {};
                const align = isNumber ? 'right' : 'left';
                return (<TableCell align={align} key={i} style={style} colSpan={colspan}>{rowName}</TableCell>);
              })}
            </TableRow>
          </TableFooter>
        )}
      </Table>
    </TableContainer>
  ));
};
